<template>
  <div class="container">
    <div class="wrap z-flex">
      <myLeft></myLeft>
      <div class="my-r">
        <myTop></myTop>
        <div class="box-con my-box">
          <myNav :activeMynav="'members'"></myNav>
          <div class="bd">
            <div class="my-list">
              <el-table :data="list" style="width: 100%" :row-class-name="tableRowClassName">
                <el-table-column prop="number" label="序号"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column label="到期时间" width="250px">
                  <template slot-scope="scope">
                    <div class="z-flex">
                      <span>{{ scope.row.expiration }}</span>
                      <el-tag type="danger" size="mini" style="margin-left: 6px;" v-if="scope.row.expire_remind!='' && scope.row.expire_remind=== '会员即将到期'">{{ scope.row.expire_remind }}</el-tag>
                      <el-tag type="info" size="mini" style="margin-left: 6px;" v-if="scope.row.expire_remind!='' && scope.row.expire_remind=== '会员已到期'">{{ scope.row.expire_remind }}</el-tag>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="图库数量">
                  <template slot-scope="scope">
                    <span :class="['img-num',scope.row.imgNum<=50?'color-main':'']">{{ scope.row.imgNum }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="awardsNum" label="获奖数量"></el-table-column>
              </el-table>
              <!-- 分页 -->
              <el-pagination 
                class="pagination" 
                background 
                layout="prev, pager, next" 
                :page-size="length"
                :total="totalNum"
                hide-on-single-page
                @current-change="changePage"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myLeft from "@/components/my/myLeft";
import myTop from "@/components/my/myTop";
import myNav from "@/components/my/myNav";
export default {
  components: {
    myLeft,
    myTop,
    myNav,
  },
  data() {
    return {
      curPage:1,
      totalNum:0,
      length: 8,
      list:[],
    };
  },
  computed: {
    
  },
  mounted() {
    this.getMemberList()
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    //分页
    changePage(e){
      this.curPage = e;
      this.getMemberList();
    },
    getMemberList(){
      const loading = this.$loading({target:'.my-list',});
      this.offset = this.length * (this.curPage - 1);
      this.$axios.api.request({
        url: "/api/qtclub/user/promoteUserList",
        data: {
          offset: this.offset,
          length: this.length
        }
      }, (res) => {
        loading.close();
        this.totalNum = res.data.total;
        this.list = res.data.list;
      })
    },
    //表格高亮提醒
    tableRowClassName({row, rowIndex}) {
      if (row.expire_remind != '') {
        return 'warning-row';
      } 
      return '';
    }
  },
};
</script>

<style lang="scss" scoped>
.wrap{
  align-items: flex-start;
}
.el-button{
  i{
    margin:0 5px 0 0;
  }
}
.my-box{
  ::v-deep .bd{
    padding: 20px;
    .my-list{
      .el-table{
        th{
          background:#f5f5f5;
        }
        .warning-row {
          background: oldlace;
        }
      }
    }
  }
}
</style>
